import { render, staticRenderFns } from "./PATList.vue?vue&type=template&id=37b6ebbb&"
import script from "./PATList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PATList.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports